import { createFileRoute, notFound } from '@tanstack/react-router';

import { pageHead } from '@/lib/head';
import { isTranslated, policies, translatedLocales } from '@/lib/source';
import { m } from '@/paraglide/messages';
import { getLocale } from '@/paraglide/runtime';

import { LegalDocument } from '../../-page.document';

export const Route = createFileRoute('/legal/policies/$slug/')({
  // No server function: this runs in the browser on client-side navigation too (ADR 015). The
  // loader only returns strings, so the document itself is read from the collection below.
  loader: async ({ params }) => {
    const doc = policies.getPage([params.slug], getLocale());
    if (!doc) throw notFound();
    await doc.data.preload();
    return {
      title: doc.data.title,
      description: doc.data.description ?? '',
      url: doc.url,
      translated: translatedLocales(policies, [params.slug]),
      image: `/og/legal/policies/${params.slug}.webp`,
    };
  },
  head: ({ loaderData }) =>
    pageHead({
      title: loaderData?.title ?? m.legal_policies_fallback(),
      description: loaderData?.description ?? '',
      canonical: loaderData?.url ?? '/legal',
      image: loaderData?.image,
      type: 'article',
      translated: loaderData?.translated,
      breadcrumbs: loaderData && [
        { name: m.legal_breadcrumb(), path: '/legal' },
        { name: loaderData.title, path: loaderData.url },
      ],
    }),
  component: PolicyDocPage,
});

function PolicyDocPage() {
  const { slug } = Route.useParams();
  const doc = policies.getPage([slug], getLocale());
  if (!doc) throw notFound();

  return (
    <LegalDocument
      title={doc.data.title}
      published={doc.data.published}
      lastModified={doc.data.lastModified}
      toc={doc.data.toc}
      body={doc.data.body}
      translated={isTranslated(doc)}
    />
  );
}
